import { Routes } from "@angular/router";
import { advancedSurfacesAccessGuard } from "./guards/advanced-surfaces-access.guard";
import { authGuard } from "./guards/auth.guard";
import { authorizationGuard } from "./guards/authorization.guard";
import { plannerAccessGuard } from "./guards/planner-access.guard";
import { ServiceStatusComponent } from "./pages/service-status/service-status.component";
import { RouteType } from "./route-type";
import { AuthenticationService } from "./services/authentication.service";

export { RouteType } from "./route-type";

export const routes: Routes = [
    //region Redirects

    // Remain compatible with the old /map/measuringpoints route
    { path: "map/measuringpoint/:locationId/:mpId/:tab", redirectTo: "locations/:locationId/:mpId/:tab" },

    //endregion

    {
        path: "status",
        component: ServiceStatusComponent,
        data: { name: "serviceStatus.title" },
    },
    {
        path: "about",
        loadChildren: () => import("./pages/about/about.routing").then((m) => m.ABOUT_ROUTES),
        data: { name: "about.title" },
    },
    {
        path: "administration",
        loadChildren: () =>
            import("./pages/administration/administration.routing").then((m) => m.ADMINISTRATION_ROUTES),
        canActivate: [authGuard, authorizationGuard],
        data: {
            name: "administration.title",
            rights: AuthenticationService.getRightsPerRoute(RouteType.Administration),
        },
    },
    {
        path: "configuration",
        loadChildren: () => import("./pages/configuration/configuration.routing").then((m) => m.CONFIGURATION_ROUTES),
        canActivate: [authGuard, authorizationGuard],
        data: {
            name: "management.title",
            rights: AuthenticationService.getRightsPerRoute(RouteType.Configuration),
        },
    },
    {
        path: "data",
        loadChildren: () => import("./pages/data/data.routing").then((m) => m.DATA_ROUTES),
        canActivate: [authGuard, authorizationGuard, advancedSurfacesAccessGuard],
        data: { name: "reports.title", rights: AuthenticationService.getRightsPerRoute(RouteType.Data) },
    },
    {
        path: "devices",
        loadChildren: () => import("./pages/devices/devices.routing").then((m) => m.DEVICES_ROUTES),
        canActivate: [authGuard, authorizationGuard],
        data: { name: "devices.title", rights: AuthenticationService.getRightsPerRoute(RouteType.Devices) },
    },
    {
        path: "documentation",
        loadChildren: () => import("./pages/documentation/documentation.routing").then((m) => m.DOCUMENTATION_ROUTES),
        canActivate: [authGuard],
        data: { name: "documentation.title" },
    },
    {
        path: "history",
        loadChildren: () => import("./pages/history/history.routing").then((m) => m.HISTORY_ROUTES),
        canActivate: [authGuard, authorizationGuard, advancedSurfacesAccessGuard],
        data: { name: "history.title", rights: AuthenticationService.getRightsPerRoute(RouteType.History) },
    },
    {
        path: "link",
        loadChildren: () => import("./pages/link/link.routing").then((m) => m.LINK_ROUTES),
        canActivate: [authGuard, authorizationGuard],
        data: { name: "manageLink.title", rights: AuthenticationService.getRightsPerRoute(RouteType.Link) },
    },
    {
        path: "locations",
        loadChildren: () => import("./pages/installations/installations.routing").then((m) => m.INSTALLATION_ROUTES),
        canActivate: [authGuard, authorizationGuard],
        data: { name: "locations.title", rights: AuthenticationService.getRightsPerRoute(RouteType.Locations) },
    },
    {
        path: "groups",
        loadChildren: () => import("./pages/groups/groups.routing").then((m) => m.GROUPS_ROUTES),
        canActivate: [authGuard, authorizationGuard, advancedSurfacesAccessGuard],
        data: { name: "map.title", rights: AuthenticationService.getRightsPerRoute(RouteType.Groups) },
    },
    {
        path: "notifications",
        loadChildren: () => import("./pages/notifications/notifications.routing").then((m) => m.NOTIFICATIONS_ROUTES),
        canActivate: [authGuard],
        data: { name: "notifications.title" },
    },
    {
        path: "qr",
        loadChildren: () => import("./pages/qr/qr.routing").then((m) => m.QR_ROUTES),
        data: { name: "qr.title" },
    },
    {
        path: "reports",
        loadChildren: () => import("./pages/reports/reporting.routing").then((m) => m.REPORTING_ROUTES),
        canActivate: [authGuard, authorizationGuard],
        data: { name: "reports.title", rights: AuthenticationService.getRightsPerRoute(RouteType.Reports) },
    },
    {
        path: "planner",
        loadChildren: () => import("./pages/planner/planner.routing").then((m) => m.PLANNER_ROUTES),
        canActivate: [authGuard, authorizationGuard, plannerAccessGuard],
        data: { name: "planner.title", rights: AuthenticationService.getRightsPerRoute(RouteType.Planning) },
    },
    {
        path: "scenarios",
        loadChildren: () => import("./pages/scenarios/scenarios.routing").then((m) => m.SCENARIOS_ROUTES),
        canActivate: [authGuard, authorizationGuard, advancedSurfacesAccessGuard],
        data: { name: "scenarios.title", rights: AuthenticationService.getRightsPerRoute(RouteType.Scenarios) },
    },
    {
        path: "**",
        redirectTo: "locations",
    },
];
